import React from "react";
import BaseButton from "./BaseButton";
import { RightOutlined } from '@ant-design/icons';
import './BaseStyle.css'

const BaseNext = (props) =>
  <BaseButton type="primary" className={ "next-button" }{ ...props } >{ props.text ? props.text : "Next Page" } <RightOutlined className="next-button-icon" /> </BaseButton>

export default BaseNext;
